import React from 'react'
//import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { setVideoPlayer } from '../../action/action'
import './videoPlayer.css'

class VideoPlayer extends React.Component {

  closePlayer = () => {
    this.props.setVideoPlayer(false);
  }

  render() {
    return (
      <div className="videoPlayer top">
        <button
          className="closePlayer"
          onClick={this.closePlayer}>
          <i
            style={{ color: "white"}}
            class="fa fa-close">
          </i>
        </button>
        <video
        className="player"
          autoplay
          controls
          >
          <source src={this.props.path} type="video/mp4" />
        </video>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    path : state.store.movies.videoPath
  }
}

export default connect(
  mapStateToProps,
  {
    setVideoPlayer
  }
)(VideoPlayer);